module.exports = __webpack_public_path__ + "img/ic_dashboard_live.6c609f0e.svg";